import * as $ from "jquery";
import "select2";

namespace PFF.controllers.replacementParts {

	//this if for the restore showerhead innovation page
	function initMobileCategoryNav() {
		var $selectMenu = $('.js-replacement-parts-select');
		var $categoryListContent = $('.js-replacement-parts-categories');

		$selectMenu.select2({
			placeholder: 'Select a Category',
			minimumResultsForSearch: -1, // hide the search box
			templateResult: function (item) {
				if (!item.element) return;

				let imgPath: string = $(item.element).data('image-path');
				let itemHtml;

				if(imgPath) {
					itemHtml = `
					<div>
						<img class="padding-right-tiny" width="40" src=${imgPath}>
						<span>${item.text}</span>
					</div>`;
				} else {
					itemHtml = `
					<div>
						<div class="padding-vertical-tiny">${item.text}</div>
					</div>`;
				}


				return $(itemHtml);
			}
		});

		$selectMenu.on("change", function () {
			let url = $(this).val(); // get selected value
			if (url) { // require a URL
				window.location.href = url; // redirec
			}
			return false;
		});
	}


	export function init() {
		initMobileCategoryNav();
	}
}

PFF.controllers.replacementParts.init();



// WEBPACK FOOTER //
// ./js/PFF/controllers/replacementParts.ts